import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { cache, invalidateUrl } from '@appbase/util'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as types from '@mail/store/types'
import * as globalTypes from '@/store/types'
@Component({
    components: { },
    computed: {
        ...mapGetters({
            currentPage: globalTypes.CURRENT_PAGE,
            selectList: types.EMAIL_SELECT
        })
    },
    methods: {
        ...mapActions({
            currentEmail: types.EMAIL_CURRENT
        }),
        ...mapMutations({
            selectEmail: types.EMAIL_SELECT
        })
    },
})
export default class MailListItem extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) isChecked!: boolean
    @Prop({ type: Boolean, default: false }) toggle!: boolean
    @Prop({ type: Object }) item!: mail.EmailMessage

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentPage!: any
    selectList!: string[]

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    currentEmail!: (selection: mail.EmailSelectionInfo) => void

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    
    selectEmail!: (id: string) => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    avatar = {
        url: '',
        loading: false,
    }

    loadingImage: string = invalidateUrl('/cm/gres/v1/img/ghost_loading.png')
    ghostImage: string = invalidateUrl('/cm/gres/v1/img/ghost.png')

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    // 보낸 편지함, 보낼 편지함, 예약메일함 여부
    get isSend(): boolean {
        const wellknownName = this.currentPage.wellKnownFolderName as string
        if (
            ['sentitems', 'outbox', 'drafts'].includes(wellknownName)
        ) {
            return true;
        } else {
            return false;
        }
    }

    get name(): any {
        // 보낸 편지함 또는 보낼 편지함에서는 목록에 표시할 이름을 받는사람으로
        if (this.isSend) {
            return this.item.displayTo || this.$t('W_Mail_Unknown').toString()
        } else {
            return this.item.from
        }
    }

    get isSelected() {
        return this.selectList.includes(this.item.id) ? true : false
    }

    @Watch('item')
    onItemChanged(newValue?: mail.EmailMessage) {
        if (newValue) {
        this.getImage(newValue.address!)
        }
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    onPhotoError() {
        console.log('set ghost image')
        this.avatar.url = this.ghostImage
    }

    errorGhost(e: Event) {
        var elem = e.srcElement as HTMLImageElement
        elem.src = '/cm/gres/faux/images/ghost.png'
    }

    checked() {
        const { id } = this.item
        this.selectEmail(id)
    }
    
    getMailDate(sendDate: string, sendTime: string) {
        let today = new Date()
        var todayString: string =
            today.getFullYear() +
            '-' +
            this.pad((today.getMonth() + 1).toString(), 2) +
            '-' +
            this.pad(today.getDate().toString(), 2)
        if (sendDate != todayString) {
            return sendDate
        } else {
            return sendTime
        }
    }

    pad(n: string, width: number) {
        n = n + ''
        return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    }

    getImage(senderMail: string) {
        this.avatar.loading = true
        const szAddress = senderMail
        if (!this.isSend) {
            cache.avatar.get(szAddress).then((url) => {
                this.avatar.url = invalidateUrl(url)
                this.avatar.loading = false
            })
        }
    }

    getMailReadClass(isMailRead: string) {
        if (isMailRead == null) {
            return ''
        } else if (isMailRead.toLowerCase() == 'true') {
            return ''
        } else {
            return 'unread-mail'
        }
    }

    select() {
        this.currentEmail({ id: this.item.id, method: 'none' })
        const getTargetPath = (id: string) => {
            if (this.item.isDraft === 'True') {
                return {
                    name: 'mail-write',
                    query: { id, type: 'draft' },
                }
            } else {
                return {
                    name: 'mail-read',
                    query: { id },
                }
            }
        }
        this.$router.push(getTargetPath(this.item.id))
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        if (this.item) {
            this.getImage(this.item.address)
        }
    }
}